/*
  37 - ArrowUp
  38 - ArrowDown
  39 - ArrowRight
  40 - ArrowLeft
  32 - Space
  33 - PageUp
  34 - PageDown
  35 - End
  36 - Home
*/
export const SCROLL_RELATED_KEYS = new Set([37, 38, 39, 40, 32, 33, 34, 35, 36]);

// This variable is used to override the scrollbar display, see `scrollbar.scss`
export const PALANTIR_SCROLLBAR_OVERRIDE_VARIABLE = '--palantir-override-scrollbar-display';

export const IGNORED_CONTAINERS_CLASSES = ['.cdk-overlay-container'];
